
<div [ngClass]="rtl?'ui-rtl':''" dir="{{rtl?'rtl':''}}">
  <div class="flex justify-end h-full">
    <input class="hidden" aria-hidden="true" [checked]="!isChecked || isChecked2" type="checkbox" name=""
      id="sidebar-toggle" (change)="isChecked = !isChecked">
    <aside class="sidebar hidden md:block" (mouseenter)="isChecked  && isChecked2 = !isChecked2"
      (mouseleave)="isChecked  && isChecked2 = !isChecked2">
      <div class="side">
        <!-- <h1 class="brand">
          <span class="brand-icon"><img src="{{currentCompany.imagePngSrc}}" width="30"></span>
          <span class="brand-name">{{'modules.user.layout.brand' | translate: {companyName:currentCompany.name} }}</span>
          <div class="sanad-books" width="50">
            <img class="brand-icon" src="{{currentCompany.imagePngSrc}}" alt="Sanad Books Logo"  />
            <div class="brand-name">{{ 'modules.user.layout.brand' | translate: { companyName: currentCompany.name } }}</div>
          </div>
        </h1> -->
        <h1 class="brand">
          <!-- Logic for Sanad Books -->
          <div *ngIf="currentCompany?.name === 'Sanad Books'">
            <div class="sanad-books" width="50">
              <img class="brand-icon" src="{{currentCompany.imagePngSrc}}" alt="Sanad Books Logo"  />
              <div class="brand-name">{{ 'modules.user.layout.brand' | translate: { companyName: currentCompany.name } }}</div>
            </div>
          </div>
          <!-- Logic for SellMax -->
          <div *ngIf="currentCompany?.name === 'SellMax'">
            <span class="brand-icon"><img src="{{currentCompany.imagePngSrc}}" width="30"></span>
          <span class="brand-name">{{'modules.user.layout.brand' | translate: {companyName:currentCompany.name} }}</span>
          </div>
           <!-- Logic for Fulfillment Bridge -->
           <div *ngIf="currentCompany?.name === 'Fulfillment Bridge'">
           <span class="brand-icon"><img src="{{currentCompany.imagePngSrc}}" width="30"></span>
           <span class="brand-name">{{'modules.user.layout.brand' | translate: {companyName:currentCompany.name} }}</span>
          </div>
          <!-- Logic for EAI Fulfillment -->
          <div *ngIf="currentCompany?.name === 'EAI Fulfillment'">
            <span class="brand-icon"><img src="{{currentCompany.imagePngSrc}}" alt="EAI Fulfillment Logo"  width="50" ></span>
            <span class="brand-name">{{ 'modules.user.layout.brand' | translate: { companyName: currentCompany.name } }}</span>
          </div>
          <!-- Logic for Champion -->
          <div *ngIf="currentCompany?.name === 'Champion'">
            <span class="brand-icon"><img src="{{currentCompany.imagePngSrc}}" alt="Champion Logo"  width="60" ></span>
            <span class="brand-name">{{ 'modules.user.layout.brand' | translate: { companyName: currentCompany.name } }}</span>
          </div>
        </h1>
        <nav>
          <ul class="select-none" style="padding-top: 30px;">
            <li *ngIf="!isLeadGenerator">
              <!-- <a [routerLink]="['/app']" routerLinkActive="active" class="nav-item nav-item-active"> -->
              <abbr title="{{'modules.user.layout.dashboard' | translate}}">
                <a [routerLink]="['/app']" routerLinkActive="" class="nav-item nav-item-active">
                  <span class="nav-item-icon">
                    <svg-icon icon="icon-dashboard" class="icon"></svg-icon>
                  </span>
                  <span class="nav-item-name">{{'modules.user.layout.dashboard' | translate}}</span>
                </a>
              </abbr>

            </li>
            <!-- Reports -->
            <li *ngIf="isCustomer || isLeadGenerator">
              <abbr title="{{'modules.user.layout.reports' | translate}}">
                <a [routerLink]="['/app/reports']" routerLinkActive="active" class="nav-item nav-item-active">
                  <span class="nav-item-icon">
                    <i class="fa fa-bar-chart" ></i>
                  </span>
                  <span class="nav-item-name">{{'modules.user.layout.reports' | translate}}</span>
                </a>
              </abbr>
            </li>
            <!--Analytics Section in sidebar muted for now -->
            <!-- <li *ngIf="isCustomer || isLeadGenerator">
              <abbr title="{{'modules.user.layout.analytics' | translate}}">
                <a [routerLink]="['/app/analytics']" routerLinkActive="active" class="nav-item nav-item-active">
                  <span class="nav-item-icon">
                    <i class="fa fa-line-chart"></i>
                  </span>
                  <span class="nav-item-name">{{'modules.user.layout.analytics' | translate}}</span>
                </a>
              </abbr>
            </li> -->
             <!--Analytics Section in sidebar muted for now -->
            <!-- SHOPS -->
            <li *ngIf="isCustomer && !isLeadGenerator">
              <abbr title="{{'modules.user.layout.shops' | translate}}">
                <a [routerLink]="['/app/shops/list']" routerLinkActive="active" class="nav-item nav-item-active">
                  <span class="nav-item-icon">
                    <svg-icon icon="icon-shop" class="icon"></svg-icon>
                  </span>
                  <span class="nav-item-name">{{'modules.user.layout.shops' | translate}}</span>
                </a>
              </abbr>
            </li>

            <!-- <li *ngIf="isCustomer">
              <a [routerLink]="['/app/shops/list']" *ngIf="isChecked" routerLinkActive="active" class="nav-item nav-item-active">
                <span class="nav-item-icon">
                  <svg-icon icon="icon-shop" class="icon"></svg-icon>
                </span>
              </a>
              <a class="nav-item nav-item-active" *ngIf="!isChecked">
                <span class="nav-item-name">
                  <span class="nav-item-icon">
                    <svg-icon icon="icon-shop" class="icon"></svg-icon>
                  </span>
                  <div class="clearfix accordian-block nav">
                    <span class="nav-item-name">{{'modules.user.layout.shops' | translate}}</span>
                    <a [routerLink]="['/app/shops/new']" routerLinkActive="active">{{'modules.user.layout.addshop' |
                      translate}}</a>
                    <a [routerLink]="['/app/shops/list']" routerLinkActive="active">{{'modules.user.layout.shops' | translate}}</a>
                  </div>
                </span>
              </a>
            </li> -->
            <li *ngIf="isCustomer && !isLeadGenerator">
              <abbr title="{{'modules.user.layout.products' | translate}}">
                <a [routerLink]="['/app/product/list/all']" routerLinkActive="active" class="nav-item nav-item-active">
                  <span class="nav-item-icon">
                    <svg-icon icon="icon-products" class="icon"></svg-icon>
                  </span>
                  <span class="nav-item-name">{{'modules.user.layout.products' | translate}}</span>
                </a>
              </abbr>
            </li>
            <li *ngIf="isCustomer && !isLeadGenerator">
              <abbr title="{{'modules.user.layout.inbound' | translate}}">
                <a [routerLink]="['/app/asn/asntable']" routerLinkActive="active" class="nav-item nav-item-active">
                  <span class="nav-item-icon">
                    <svg-icon icon="icon-inbound2" class="icon"></svg-icon>
                  </span>
                  <span class="nav-item-name">{{'modules.user.layout.inbound' | translate}}</span>
                </a>
              </abbr>
            </li>
            <li *ngIf="isCustomer || isLeadGenerator">
              <abbr title="{{'modules.user.layout.inventory' | translate}}"> 
                <a [routerLink]="['/app/inventory/all']" routerLinkActive="active" class="nav-item nav-item-active">
                  <span class="nav-item-icon">
                    <svg-icon icon="icon-inventory" class="icon"></svg-icon>
                  </span>
                  <span class="nav-item-name">{{'modules.user.layout.inventory' | translate}}</span>
                </a>
              </abbr>
            </li>
            <li *ngIf="isCustomer">
              <abbr title="{{'modules.user.layout.orders' | translate}}">
                <a [routerLink]="['/app/orders/list']" routerLinkActive="active" class="nav-item nav-item-active">
                  <span class="nav-item-icon">
                    <svg-icon icon="icon-order" class="icon"></svg-icon>
                  </span>
                  <span class="nav-item-name">{{'modules.user.layout.orders' | translate}}</span>
                </a>
              </abbr>
            </li>
            <li *ngIf="isCustomer && isAffiliate">
              <abbr title="{{'modules.user.layout.leads' | translate}}">
                <a [routerLink]="['/app/leads/list']" routerLinkActive="active" class="nav-item nav-item-active">
                  <span class="nav-item-icon">
                    <svg-icon icon="icon-order" class="icon"></svg-icon>
                  </span>
                  <span class="nav-item-name">{{'modules.user.layout.leads' | translate}}</span>
                </a>
              </abbr>
            </li>

            <!-- <li *ngIf="isCustomer">
              <a [routerLink]="['/app/orders/list']" *ngIf="isChecked" routerLinkActive="active" class="nav-item nav-item-active">
                <span class="nav-item-icon">
                  <svg-icon icon="icon-order" class="icon"></svg-icon>
                </span>
              </a>
              <a class="nav-item nav-item-active" *ngIf="!isChecked">
                <span class="nav-item-name">
                  <span class="nav-item-icon">
                    <svg-icon icon="icon-order" class="icon"></svg-icon>
                  </span>
                  <div class="clearfix accordian-block nav">
                    <span class="nav-item-name">{{'modules.user.layout.orders' | translate}}</span>
                    <a [routerLink]="['/app/orders/create']" routerLinkActive="active">{{'modules.user.layout.addorder'
                      | translate}}</a>
                    <a [routerLink]="['/app/orders/list']" routerLinkActive="active">{{'modules.user.layout.orders' |
                      translate}}</a>
                  </div>
                </span>
              </a>
            </li> -->

            <li *ngIf="isCustomer || isLeadGenerator">
              <abbr title="{{'modules.user.layout.tracking' | translate}}">
                <a [routerLink]="['/app/tracking/trackingtable']" routerLinkActive="active"
                  class="nav-item nav-item-active">
                  <span class="nav-item-icon">
                    <svg-icon icon="icon-Tracking" class="icon"></svg-icon>
                  </span>
                  <span class="nav-item-name">{{'modules.user.layout.tracking' | translate}}</span>
                </a>
              </abbr>
            </li>
            <li *ngIf="isCustomer && !isLeadGenerator">
              <abbr title="{{'modules.user.layout.returns' | translate}}">
                <a [routerLink]="['/app/rma/list/open']" routerLinkActive="active" class="nav-item nav-item-active">
                  <!-- <span class="nav-item-icon">
                    <svg-icon icon="icon-RMA" class="icon"></svg-icon>
                  </span> -->
                  <span class="nav-item-icon">
                    <i class="pi pi-directions-alt"></i>
                  </span>
                  <span class="nav-item-name">{{'modules.user.layout.returns' | translate}}</span>
                </a>
              </abbr>
            </li>
            <li *ngIf="isCustomer && !isLeadGenerator">
              <abbr title="{{'modules.user.layout.rules' | translate}}">
                <a [routerLink]="['/app/rules/frules']" *ngIf="isChecked && !isChecked2" routerLinkActive="active"
                  class="nav-item nav-item-active">
                  <span class="nav-item-icon">
                    <svg-icon icon="icon-rules-icon" class="icon"></svg-icon>
                  </span>
                </a>
              </abbr>
              <abbr title="{{'modules.user.layout.rules' | translate}}">
                <a class="nav-item nav-item-active">
                  <span class="nav-item-name">
                    <span class="nav-item-icon">
                      <svg-icon icon="icon-rules-icon" class="icon"></svg-icon>
                    </span>
                    <div class="clearfix accordian-block-rules nav">
                      <span class="nav-item-name">{{'modules.user.layout.rules' | translate}} <i
                          class="pi pi-chevron-right"></i> </span>
                      <a [routerLink]="['/app/rules/frules']"
                        routerLinkActive="active">{{'modules.user.layout.rules.frules' | translate}}</a>
                      <a [routerLink]="['/app/rules/advancedrules/productrules/list']"
                        routerLinkActive="active">{{'modules.user.layout.rules.advancedrules' |
                        translate}}</a>
                      <a [routerLink]="['/app/rules/importrules']"
                        routerLinkActive="active">{{'modules.user.layout.rules.importrules' | translate}}</a>
                      <a [routerLink]="['/app/rules/pickupAddress']"
                        routerLinkActive="active">{{'modules.user.layout.rules.pickupAddresses' | translate}}</a>
                    </div>
                  </span>
                </a>
              </abbr>
            </li>

            <!-- BEGIN SALES ASIDE  -->
            <li *ngIf="isSales">
              <abbr title="xxxxxxxxxxxxx">
                <a [routerLink]="['/app/sales/quotation/quotation']" routerLinkActive="active"
                  class="nav-item nav-item-active">
                  <span class="nav-item-icon">
                    <svg-icon icon="icon-inbound2" class="icon"></svg-icon>
                  </span>
                  <span class="nav-item-name">{{'NAV.QUOTATION' | translate}}</span>
                </a>
              </abbr>
            </li>
            <!-- END  SALES ASIDE  -->

          </ul>
        </nav>
      </div>
    </aside>
    <main class="content">
      <div class="content-container">
        <div *ngIf="showNotice" class="notice-message" [ngClass]="{ 'rtl': isArabicLanguage() }" (click)="closeNotice()">
          <span class="info__icon"><i class="fa fa-info"></i></span>
          <p>{{ afterLoginMessage }}</p>
        </div>
        <header class="navbar flex">
          <label role="button" for="sidebar-toggle" class="cursor-pointer hidden md:inline-block">
            <i *ngIf="isChecked" class="fa fa-duotone fa-caret-right"
              style="font-size: 24px; color:#0886dad1; padding-left: 5px;"></i>
            <i *ngIf="!isChecked" class="fa fa-duotone fa-caret-left"
              style="font-size: 24px; color:#0886dad1; padding-left: 5px;"></i>


          </label>
          <p-dialog #searchDialog [(visible)]="modalWindow" [closable]="false" [style]="{width: '64vw'}" [baseZIndex]="10000" [modal]="true"
              class="custom-dialog">
                <p-header>
                  <button type="button" class="close" aria-label="Close" (click)="closeDialog()">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </p-header>
              <div class="modal-body">
                <!-- LOADING INDICATOR -->
                <div *ngIf="loading  && currentPage === 1" style="text-align: center;">
                  <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
                  <div *ngIf="loopIdx && length" style="font-size: 0.8rem">{{ loopIdx + ' of ' + length }}</div>
                </div>
                <div *ngIf="selectedData">
                  <table class="data-table">
                    <thead>
                      <tr>
                        <th *ngFor="let column of selectedData.columns">{{ column }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- START LOADING -->
                      <ng-container *ngIf="loading && currentPage > 1">
                        <tr>
                          <td colspan="7" style="text-align: center;">
                            <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
                            <div *ngIf="loopIdx && length" style="font-size: 0.8rem">{{ loopIdx + ' of ' + length }}</div>
                          </td>
                        </tr>
                      </ng-container>

                      <!-- FINISHED LOADING -->
                      <ng-container *ngIf="!loading">
                        <tr *ngFor="let row of selectedData.rows">
                          <ng-container *ngFor="let cell of row; let columnIndex = index">
                            <ng-container [ngSwitch]="selectedData.columns[columnIndex]">
                              <td *ngSwitchCase="'Reference Number'">
                                <a [routerLink]="['/app/leads/list']" [queryParams]="{ referenceNumber: cell }" routerLinkActive="active" target="_blank">{{ cell }}</a>
                              </td>
                              <td *ngSwitchCase="'Tracking Number'">
                                <a [routerLink]="['/app/tracking/trackingtable']" [queryParams]="{ trackingNumber: cell }" routerLinkActive="active" target="_blank">{{ cell }}</a>
                              </td>
                              <td *ngSwitchCase="'Order ID'">
                                <a [routerLink]="['/app/orders/list']" [queryParams]="{ orderId: cell }" routerLinkActive="active" target="_blank">{{ cell }}</a>
                              </td>
                              <td *ngSwitchCase="'Country'">
                                <i class="{{ cell.toLowerCase() }} flag"></i>
                              </td>
                              <td *ngSwitchDefault>{{ cell }}</td>
                            </ng-container>
                          </ng-container>
                        </tr>
                    </ng-container>
                    </tbody>
                  </table>
                  <p-paginator [rows]="rowsPerPage" [totalRecords]="totalRecords" [rowsPerPageOptions]="[10]"
                    [(currentPage)]="currentPage" (onPageChange)="onPageChange($event)">
                  </p-paginator>
                </div>
              </div>
            </p-dialog>
          <div>
            <nav>
              <ul class="nav">
                <li class="li-navbar">
                  <div class="search-row">
                    <div class="search-container">
                      <div class="tooltip-wrapper">
                        <input class="search-input" type="text" [(ngModel)]="filterParams.searchInput" (clear)="(filterParams.searchInput = null)" placeholder="Search By reference, order ID, phone number, name, tracking number" (focus)="showDropdown()" (click)="stopPropagation()" required>
                        <div class="tooltip">{{"Search By reference, order ID, phone number, name, tracking number" | translate}}</div>
                      </div>
                      <div class="dropdown" [hidden]="!showDropdownOptions" (click)="stopPropagation()">
                        <!-- Additional filter options here -->
                        <!-- Example: Filter by category -->
                        <div class="select-row">
                          <div class="filter-item">
                            <label for="creation-date" class="filter-label" style="width: 100%">{{"modules.user.reportsDisplay.placeholder.from" | translate}}</label>
                            <div>
                              <p-calendar [showIcon]="true" [(ngModel)]="filterParams.creationDateFrom" inputId="icon" (click)="stopPropagation()"></p-calendar>
                            </div>
                          </div>
                          <div class="filter-item">
                            <label for="creation-date" class="filter-label" style="width: 100%">{{"modules.user.reportsDisplay.placeholder.to" | translate}}</label>
                            <div>
                              <p-calendar [showIcon]="true" [(ngModel)]="filterParams.creationDateTo" inputId="icon" (click)="stopPropagation()"></p-calendar>
                            </div>
                          </div>
                          <div class="filter-item">
                            <label for="countries" class="filter-label">{{"modules.user.reportsDisplay.placeholder.countries" | translate}}</label>
                            <ng-select [items]="countriesList" bindLabel="name" placeholder="ALL Countries !" multiple="true" appendTo="body" [(ngModel)]="filterParams.countries"
                              (clear)="(filterParams.countries = null)" (click)="stopPropagation()">
                            </ng-select>
                          </div>
                          <div class="filter-item">
                            <label for="cities" class="filter-label">{{"modules.user.reportsDisplay.placeholder.cities" | translate}}</label>
                            <ng-select [items]="cities" bindLabel="name" placeholder="ALL cities !" multiple="true" appendTo="body" [(ngModel)]="filterParams.cities"
                              (clear)="(filterParams.cities = null)" (click)="stopPropagation()">
                            </ng-select>
                          </div>
                          <div class="filter-item">
                            <label for="provinces" class="filter-label">{{"modules.user.reportsDisplay.placeholder.provinces" | translate}}</label>
                            <ng-select [items]="provinces" bindLabel="name" placeholder="ALL provinces !"  multiple="true" appendTo="body" [(ngModel)]="filterParams.provinces"
                              (clear)="(filterParams.provinces = null)" (click)="stopPropagation()">
                            </ng-select>
                          </div>
                          <div class="filter-item" >
                            <label for="skus" class="filter-label">{{"modules.user.reportsDisplay.placeholder.skus" | translate}}</label>
                            <ng-select [items]="skuList" bindLabel="name" placeholder="ALL Products !"  multiple="true"  appendTo="body" [(ngModel)]="filterParams.skus"
                              (clear)="(filterParams.skus = null)" (click)="stopPropagation()" (clickOutside)="closeDropdown()">
                            </ng-select>
                          </div>
                          <div class="filter-item">
                            <label for="leadStatus" class="filter-label">{{"modules.user.reportsDisplay.placeholder.leadStatus" | translate}}</label>
                            <ng-select [items]="leadStatusList" bindLabel="name" placeholder="ALL Statuses !" appendTo="body" [(ngModel)]="filterParams.leadStatus"
                              (clear)="(filterParams.leadStatus = null)" (click)="stopPropagation()">
                            </ng-select>
                          </div>
                          <div class="filter-item">
                            <label for="orderStatus" class="filter-label">{{"modules.user.reportsDisplay.placeholder.orderStatus" | translate}}</label>
                            <ng-select [items]="orderStatusList" bindLabel="name" placeholder="ALL Statuses !" appendTo="body" [(ngModel)]="filterParams.orderStatus"
                              (clear)="(filterParams.orderStatus = null)" (click)="stopPropagation()">
                            </ng-select>
                          </div>
                          <div class="filter-item">
                            <label for="trackingStatus" class="filter-label">{{"modules.user.reportsDisplay.placeholder.trackingStatus" | translate}}</label>
                            <ng-select [items]="trackingStatusList" bindLabel="name" placeholder="ALL Statuses !" appendTo="body" [(ngModel)]="filterParams.trackingStatus"
                              (clear)="(filterParams.trackingStatus = null)" (click)="stopPropagation()">
                            </ng-select>
                          </div>
                          <div class="filter-item">
                            <label for="payment" class="filter-label">{{"modules.user.reportsDisplay.placeholder.paymentType" | translate}}</label>
                            <ng-select [items]="paymentList" bindLabel="name" placeholder="ALL !" appendTo="body" [(ngModel)]="filterParams.paymentType"
                              (clear)="(filterParams.paymentType = null)" (click)="stopPropagation()" (clickOutside)="closeDropdown()">
                            </ng-select>
                          </div>
                          <!-- Add more select elements here -->
                        </div>
                      </div>
                    </div>
                    <button class="search-button" (click)="openDialog()">Search</button>
                  </div>
                </li>
                <ng-container *ngIf="!isLeadGenerator">
                <li class="li-navbar">
                  <label class="balance"
                    style="color: #00C48C; font-weight: 600; font-size: 12px;">{{"modules.user.layout.balance" |
                    translate}} | </label>
                  <label style="font-size: 12px; padding-left: 2px;"> {{balance}}{{currentCompany.currencySymbol}}</label>
                </li>

                <li class="li-navbar">
                  <label
                    style="color: #FF546F; font-weight: 600; font-size: 12px; margin-right: 5px; margin-left: 5px;">{{"modules.user.layout.creditlimit"
                    | translate}} | </label>
                  <label style="font-size: 12px;"> {{limit}}{{currentCompany.currencySymbol}}</label>
                </li>

                <li class="li-navbar">
                  <a *ngIf="isSales" [routerLink]="['/app/sales/shipping/fee']" routerLinkActive="active"
                    class="nav-item nav-item-active a-navbar">
                    <span class="navbar-item-icon">
                      <svg-icon icon="icon-calculator" class="icon" style="width: 20px; height: 20px; margin-top:5px">
                      </svg-icon>
                    </span>
                  </a>
                  <a *ngIf="isCustomer" [routerLink]="['/app/shippingcalculator/calculator']"
                    title=" {{ 'modules.user.layout.calculator' | translate}} " routerLinkActive="active"
                    class="nav-item nav-item-active a-navbar">
                    <svg-icon icon="icon-calculator" class="icon" style="width: 20px; height: 20px; margin-top:5px">
                    </svg-icon>
                  </a>
                </li>
              </ng-container>
                <li class="li-navbar-bell">
                  <button class="bell-icon" (click)="showNotifications()">
                  <i class="fa fa-bell"><span class="notif-count">{{ getUnreadMessageCount() }}</span></i>
                  </button>
                  <ul class="dropdown-list" *ngIf="notificationsOpen">
                  <li class="header-li"><h4 class="notification-header">Notifications</h4></li>
                  <li class="dropdown-notifications" *ngFor="let message of visibleMessages">
                  <div class="message-container" [ngClass]="getMessageClass(message?.headers?.header, message?.read)">
                  <i class="fa fa-message" [ngClass]="getMessageIcon(message?.headers?.header)"></i>
                  <span class="message-text">{{ message?.body }}</span>
                  </div>
                  <span class="notification-date">{{ datePipe.transform(message?.headers?.timestamp, 'dd MMM, h:mm a') }}</span>
                  </li>
                  </ul>
                </li> 
                <li class="li-navbar profile">
                  <a routerLinkActive="active" class="nav-item nav-item-active a-navbar">
                    <span class="navbar-item-icon" style="display: inline-block;">
                      <div *ngIf="companyConnected?.company?.logo == null">
                        <img class="avatar" alt="avatar" src="../assets/images/avatar-register.png" width="25"
                          height="25" style="margin-top: 5px;">
                      </div>
                      <div *ngIf="companyConnected?.company?.logo != null">
                        <img class="avatar" alt="company" src="{{companyConnected?.company?.logo}}" width="25"
                          height="25" style="margin-top: 5px;">
                      </div>

                      <h3 class="profile-name" style="margin-top: 10px;">{{username || ""}}</h3>
                    </span>
                  </a>
                  <ul class="dropdown-profile" style="z-index: 3;">
                    <li class="dropdown-profile"><a class="dropdown-profile" [routerLink]="['/app/profile']"
                        routerLinkActive="active">{{'modules.user.layout.profile' |
                        translate}}</a></li>
                    <ng-container *ngIf="!isLeadGenerator">
                        <li *ngIf="isCustomer" class="dropdown-profile"><a class="dropdown-profile"
                          [routerLink]="['/app/Terms&Conditions/contract']"
                          routerLinkActive="active">{{'modules.user.layout.Terms&Conditions' |
                          translate}}</a></li>
                    <li *ngIf="isCustomer" class="dropdown-profile"><a class="dropdown-profile"
                        [routerLink]="['/app/insurance/contract']"
                        routerLinkActive="active">{{'modules.user.layout.insurance' |
                        translate}}</a></li>

                    <li *ngIf="isCustomer" class="dropdown-profile"><a class="dropdown-profile"
                        [routerLink]="['/app/billing/topup']" routerLinkActive="active">{{'modules.user.layout.topup' |
                        translate}}</a></li>
                    <li *ngIf="isCustomer" class="dropdown-profile">
                      <a class="dropdown-profile" [routerLink]="['/app/billing/transactions']"
                        routerLinkActive="active">{{'modules.user.layout.transactions' |
                        translate}}</a>
                    </li>
                    </ng-container>
                    <li class="dropdown-profile">
                      <div class="dropdown-profile" (click)="logout()">{{ 'NAV.LOGOUT' | translate }}</div>
                    </li>
                  </ul>
                </li>
                
                
                <li class="li-navbar">
                  <div class="languages-selector" style="display: inline-block;">
                    <div>
                      <p-dropdown [options]="languages" [(ngModel)]="selectedCountry" optionLabel="name"
                        [showClear]="true" placeholder="{{'modules.user.placeholder.selectacountry' | translate }}"
                        (ngModelChange)="languageChanged($event)">
                        <ng-template pTemplate="selectedItem">
                          <div class="country-item country-item-value" *ngIf="selectedCountry">
                            <img class="flag-language"
                              src="../../../assets/images/flags/{{selectedCountry.language}}.png" width="20" />
                            <!-- <div>{{selectedCountry.name}}</div> -->
                          </div>
                        </ng-template>
                        <ng-template let-country pTemplate="item">
                          <div class="country-item">
                            <img class="flag-language-dropdown"
                              src="../../../assets/images/flags/{{country.language}}.png" width="20" />
                            <div class="text-language-dropdown">{{country.name}}</div>
                          </div>
                        </ng-template>
                      </p-dropdown>
                    </div>
                  </div>
                </li>
                <li class="li-navbar" style="display: none;">
                  <button class="toggle-theme" (click)="switchTheme()"
                    style="vertical-align: middle; margin-top: -6px;">
                    {{ (theme === "light-theme" ? "modules.user.layout.theme.dark" : "modules.user.layout.theme.light")
                    | translate }}
                  </button>
                </li>
                

              </ul>
              
            </nav>
            
          </div>
          
        </header>
        <div style="width: 100%; height: 100%; padding: 20px;">
          <router-outlet></router-outlet>
        </div>
      </div>
    </main>
  </div>
